import { useState, useEffect } from 'react';
import { base44 } from '@/api/base44Client';

export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: '§ Úrval · 2026',
    title: 'Vintage Treyjur',
    body: 'Upprunalegar vintage fótboltatreyjur. Skoðaðu úrvalið á netinu eða komdu til okkar á Bíldshöfða 16.',
    badge1: 'Upprunalegar fótboltatreyjur',
    badge2: 'Nýjar treyjur vikulega',
    badge3: 'Söfnuð í Reykjavík',
  },
  categories: {
    eyebrow: '§ Flokkar',
    title: 'Skoðaðu úrvalið eftir flokkum',
    subtitle: 'Finndu þína treyju.',
    items: [
      { label: 'LANDSLIÐ', image: 'https://media.base44.com/images/public/6aa2c2af54cfb5bf4d045125/9ae344498_generated_image.png' },
      { label: 'FÉLAGSLIÐ', image: 'https://media.base44.com/images/public/6aa2c2af54cfb5bf4d045125/8ae402cec_generated_image.png' },
      { label: 'ÍSLENSKAR TREYJUR', image: 'https://media.base44.com/images/public/6aa2c2af54cfb5bf4d045125/33239c8fe_generated_image.png' },
    ],
  },
  about: {
    eyebrow: '§ Sagan',
    title: 'Treyjur með sögu.',
    body: 'Vintage Treyjur sérhæfir sig í upprunalegum fótboltatreyjum frá ólíkum tímabilum. Nýjar treyjur koma reglulega í sölu og hægt er að skoða þær hjá okkur inni í Classic Detail á Bíldshöfða 16.',
    image: 'https://media.base44.com/images/public/6aa2c2af54cfb5bf4d045125/526f79f27_generated_image.png',
    stat1_num: '100%', stat1_label: 'Ósviknar',
    stat2_num: '∞', stat2_label: 'Skráðar',
    stat3_num: '2026', stat3_label: 'Safnað frá',
  },
  testimonials: {
    eyebrow: '§ Umsagnir',
    title: 'Úr minningabók safnarans',
    items: [
      { text: 'Fann loksins Ítalíu \'90 treyjuna sem ég hef verið að leita að í áratug. Ástand frábært og sögupátturinn á bak við hana gerði hana enn sérstakari.', name: 'Jónas P.', role: 'Safnari · Reykjavík', jersey: 'Ítalía 1990' },
      { text: 'Ekki bara verslun — það er eins og maður gangi inn í fótboltasafn. Hver treyja er ósvikin og vel varðveitt. Mæli eindregið með.', name: 'María H.', role: 'Þjálfari · Akureyri', jersey: 'Brasilía 1998' },
      { text: 'Þjónusta og þekking ótrúleg. Þeir sögðu mér söguna á bak við hverja treyju. Þetta er meira en verslun — það er safn.', name: 'Davíð R.', role: 'Fótboltaaðdáandi', jersey: 'Danmörk 1986' },
    ],
  },
  visit: {
    eyebrow: '§ Heimsókn',
    title: 'Komdu og skoðaðu treyjurnar.',
    body: 'Allar treyjurnar á vefnum er hægt að skoða hjá okkur inni í Classic Detail á Bíldshöfða 16, inn í portinu. Þú getur því skoðað treyjuna áður en þú kaupir.',
    address: 'Bíldshöfði 16, 110 Reykjavík',
    detail1_label: 'Heimilisfang', detail1_value: 'Bíldshöfði 16, 110 Reykjavík',
    detail2_label: 'Inni í', detail2_value: 'Classic Detail — inn í portinu',
    detail3_label: 'Sími', detail3_value: '868 3765',
    detail4_label: 'Tölvupóstur', detail4_value: 'vintagetreyjur@gmail.com',
    hours1_day: 'Mán – Fim', hours1_time: '10:00 – 18:00',
    hours2_day: 'Föstudagur', hours2_time: '10:00 – 17:00',
    hours3_day: 'Laugardagur', hours3_time: '11:00 – 15:00',
    hours4_day: 'Sunnudagur', hours4_time: 'Lokað',
  },
  drop: {
    eyebrow: '§ Nýjar treyjur',
    title: 'Nýjar treyjur reglulega',
    body: 'Nýjar treyjur koma reglulega í sölu. Þeir sem eru á póstlistanum fá forskot áður en þær fara í almenna sölu.',
    countdown_label: 'Næsta sala hefst eftir',
    newsletter_placeholder: 'Netfang þitt',
    newsletter_btn: 'Skrá mig',
    newsletter_success: 'Takk — þú ert á póstlistanum.',
    preview_link: 'Skoða kynningu',
  },
  sell: {
    eyebrow: '§ Selja með okkur',
    title: 'Seldu treyjuna með okkur',
    body: 'Áttu fótboltatreyju sem þú vilt selja? Við getum tekið hana í umboðssölu. Við sjáum um myndir, auglýsingu, vörslu og sölu. Þú færð 80% af söluverðinu og við tökum 20%.',
    feature1: 'Ókeypis mat og ráðgjöf',
    feature2: 'Þú færð greitt þegar treyjan selst',
    split_you: 'Þú færð',
    split_us: 'Við tökum',
    form_title: 'Senda inn treyju',
    form_body: 'Sendu okkur helstu upplýsingar og nokkrar myndir. Við höfum síðan samband.',
    success_eyebrow: 'Beiðni móttekin',
    success_title: 'Takk fyrir',
    success_body: 'Við skoðum upplýsingarnar og höfum samband fljótlega.',
    success_link: 'Til baka heim',
    submit_btn: 'Senda',
  },
  dream: {
    eyebrow: 'Draumatreyja',
    title: 'Ertu að leita að draumatreyjunni?',
    body: 'Finnurðu ekki treyjuna sem þú ert að leita að? Sendu okkur upplýsingar um hana og við reynum að finna eintak sem passar.',
    feature1: 'Við leitum hjá birgjum og söfnurum',
    feature2: 'Þú færð tilboð þegar við finnum treyjuna',
    feature3: 'Þú ákveður hvort þú kaupir þegar við finnum hana',
    form_title: 'Senda beiðni',
    form_body: 'Lýstu draumatreyjunni þinni og við reynum að finna hana.',
    success_eyebrow: 'Beiðni móttekin',
    success_title: 'Takk fyrir',
    success_body: 'Við förum af stað í leitina og höfum samband ef við finnum treyju sem passar við beiðnina.',
    success_link: 'Til baka heim',
    submit_btn: 'Senda',
  },
  aboutPage: {
    eyebrow: '§ Um okkur',
    title: 'Um Vintage Treyjur',
    body1: 'Vintage Treyjur varð til út frá áhuga mínum á gömlum fótboltatreyjum og sögunum sem fylgja þeim. Starfsemin er rekin inni í Classic Detail á Bíldshöfða 16 í Reykjavík.',
    body2: 'Ég vel treyjurnar sjálfur og skoða meðal annars merki, framleiðanda, tímabil, prentun og önnur atriði sem skipta máli þegar uppruni treyju er metinn.',
    body3: 'Það skemmtilegasta við gamlar treyjur er sagan. Tímabilið, leikmennirnir, styrktaraðilinn og útlitið geta strax minnt mann á ákveðið lið eða ákveðinn tíma í fótboltanum.',
    body4: 'Þú getur skoðað úrvalið hér á síðunni eða komið til okkar í Classic Detail á Bíldshöfða 16.',
    image: 'https://media.base44.com/images/public/6aa2c2af54cfb5bf4d045125/7aec4e703_generated_image.png',
  },
  checkout: {
    cart_eyebrow: 'Karfa',
    empty_title: 'Karfan er tóm',
    empty_link: 'Skoða úrvalið',
    back_link: 'Áfram að versla',
    title: 'Ganga frá kaupum',
    items_label: 'Í körfu',
    delivery_label: 'Afhending',
    pickup_title: 'Sækja í verslun',
    pickup_body: 'Inni í Classic Detail — Bíldshöfða 16, Reykjavík',
    pickup_note: 'Pantanir fyrir kl. 16 á virkum dögum eru tilbúnar samdægurs.',
    pickup_badge: 'Inni í Classic Detail',
    dropp_title: 'Senda með Dropp',
    dropp_badge: '890–1.090 kr. á afhendingarstað · 1.410–1.790 kr. heimsent',
    summary_label: 'Samantekt',
    items_count_label: 'Atriði',
    total_label: 'Samtals',
    submit_btn: 'Staðfesta pöntun',
    submitting_btn: 'Sendi...',
    success_eyebrow: 'Pöntun móttekin',
    success_title: 'Takk fyrir kaupin',
    success_body: 'Greiðslan er staðfest og kvittun hefur verið send á netfangið þitt.',
    success_order_num: 'Pöntunarnúmer:',
    success_link: 'Til baka heim',
    remove_btn: 'Fjarlægja',
    shipping_fee: 1600,
  },
  ticker: {
    items: [
      'Nýjar treyjur reglulega',
      'Upprunalegar fótboltatreyjur',
      'Söfnuð í Reykjavík',
      'Frá landsliðum til félagsliða',
      'Engar eftirlíkingar',
      'Sjaldgæfar treyjur',
    ],
  },
  footer: {
    description: 'Upprunalegar vintage fótboltatreyjur. Inni í Classic Detail á Bíldshöfða 16.',
    address: 'Bíldshöfði 16, 110 Reykjavík',
    phone: '868 3765',
    email: 'vintagetreyjur@gmail.com',
  },
  measurements: {
    heading: 'Mælingar',
    chest_label: 'Bringumál',
    length_label: 'Lengd',
    note: 'Bringumál er mælt flatt frá handarkrika til handarkrika (pit-to-pit).',
  },
  faq: {
    eyebrow: '§ Upplýsingar',
    title: 'Algengar spurningar',
    intro: 'Hér finnur þú svör við algengustu spurningunum. Ef þú finnur ekki svarið sem þú leitar að skaltu endilega hafa samband.',
    items: [
      { q: 'Hvernig eru stærðirnar?', a: 'Stærðir á eldri treyjum geta verið frábrugðnar stærðum í dag. Við mælum með að skoða mælingarnar á vörusíðunni og bera þær saman við treyju sem passar þér vel.' },
      { q: 'Hvað þýðir ástandseinkunnin?', a: 'Hver treyja fær ástandseinkunn af 10. Við horfum meðal annars á slit, bletti, hnoðra, sauma og ástand merkja og prentunar. Ef gallar eru á treyjunni tökum við þá fram í lýsingunni og sýnum á myndum þegar það á við.' },
      { q: 'Hvernig er skilarétturinn?', a: '14 daga skilaréttur gildir um kaup í vefverslun. Treyjan þarf að vera í sama ástandi og þegar hún var afhent. Hafðu samband við okkur á vintagetreyjur@gmail.com ef þú vilt skila pöntun.' },
      { q: 'Hvað ef treyjan stenst ekki lýsinguna?', a: 'Við leggjum okkur fram um að lýsa hverri treyju eins nákvæmlega og hægt er og taka fram galla ef einhverjir eru. Ef eitthvað er ekki eins og lýst var skaltu hafa samband við okkur á vintagetreyjur@gmail.com og við leysum málið.' },
      { q: 'Hvernig virka sendingar?', a: 'Þú getur annað hvort sótt treyjuna hjá okkur inni í Classic Detail, Bíldshöfða 16, eða fengið hana senda með Dropp. Heimsending með Dropp kostar 1.410–1.790 kr. eftir svæði og afhending á Dropp-stað kostar 890–1.090 kr. eftir staðsetningu. Pantanir sem berast fyrir kl. 16 á virkum dögum eru sendar frá okkur samdægurs. Ef þú velur að sækja er treyjan einnig tilbúin samdægurs þegar pantað er fyrir kl. 16 á virkum dögum.' },
      { q: 'Eru treyjurnar upprunalegar?', a: 'Já. Við seljum aðeins upprunalegar fótboltatreyjur. Við skoðum merki, framleiðanda, tímabil, prentun og önnur atriði sem skipta máli við mat á uppruna. Ef óvissa er um treyju er hún ekki seld sem staðfest upprunaleg treyja.' },
    ],
    contact_text: 'Fannstu ekki svarið? Sendu okkur línu á vintagetreyjur@gmail.com.',
    contact_email: 'vintagetreyjur@gmail.com',
  },
  quiz: {
    header_label: 'Treyjuþraut dagsins',
    streak_day: 'dagur',
    streak_days: 'daga',
    streak_suffix: 'í röð',
    question_progress: 'Spurning',
    correct_feedback: 'Rétt!',
    wrong_feedback: 'Rangt...',
    all_correct_title: 'Til hamingju!',
    all_correct_body: 'Þú náðir öllum {count} spurningum réttum í dag!',
    game_over_title: 'Úr leik',
    game_over_body: 'Þú náðir {count} spurningum réttum.',
    completion_message: 'Þú hefur lokið Treyjuþraut dagsins!',
    already_played: 'Þú hefur nú þegar klárað Treyjuþraut dagsins',
    game_finished: 'Leik lokið í dag',
    come_back: 'Reyndu aftur á morgun',
    share_btn: 'Deila niðurstöðu',
    share_copied: 'Afritað! Nú getur þú límt þetta hvar sem er.',
    share_text: 'Ég náði {count} spurningum réttum í Treyjuþraut dagsins hjá Vintage Treyjur ⚽ Getur þú gert betur?',
    share_url: 'https://vintagetreyjur.is/?open=treyjuthraut',
  },
  emails: {
    confirmation: {
      subject: 'Pöntun þín #{order_number} — Vintage Treyjur',
      body: 'Góðan daginn {name},\n\nTakk fyrir pöntunina þína hjá Vintage Treyjur.\n\nPöntunarnúmer: #{order_number}\nAfhendingarmáti: {delivery_method}\nSamtals: {total}\n\nAtriði:\n{items}\n\nEf pöntunin á að fara með Dropp sendum við treyjuna frá okkur samdægurs þegar pantað er fyrir kl. 16 á virkum dögum. Ef þú velur að sækja geturðu sótt treyjuna samdægurs þegar pantað er fyrir kl. 16 á virkum dögum.\n\nBestu kveðjur,\nVintage Treyjur\nReykjavík',
    },
    pickup_ready: {
      subject: 'Pöntun tilbúin til afhendingar — Vintage Treyjur',
      body: 'Góðan daginn {name},\n\nPöntunin þín #{order_number} er tilbúin til afhendingar hjá okkur í Classic Detail, Bíldshöfði 16, Reykjavík.\n\nOpnunartímar:\nMán–Fimmt: 10:00–18:00\nFöstudagur: 10:00–17:00\nLaugardagur: 11:00–15:00\n\nVinsamlegast hafðu pöntunarnúmerið til staðar þegar þú kemur.\n\nBestu kveðjur,\nVintage Treyjur',
    },
    shipped: {
      subject: 'Pöntun send með Dropp — Vintage Treyjur',
      body: 'Góðan daginn {name},\n\nPöntunin þín #{order_number} hefur verið send með Dropp og er á leiðinni til þín.\n\nVenjulegur afhendingarfrestur er 1–3 virkir dagar.\n\nBestu kveðjur,\nVintage Treyjur',
    },
  },
};

const LS_KEY = 'vt_site_content_v1';
const initialContent = typeof document !== 'undefined' ? document.getElementById('vt-initial-content')?.textContent : null;
let contentCache = initialContent ? { ...DEFAULT_CONTENT, ...JSON.parse(initialContent) } : null;
let contentPromise = null;

function readLocalCache() {
  if (contentCache) return contentCache;
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(LS_KEY) : null;
    if (raw) {
      contentCache = { ...DEFAULT_CONTENT, ...JSON.parse(raw) };
      return contentCache;
    }
  } catch (e) { /* ignore */ }
  return null;
}

function fetchSiteContent() {
  if (contentPromise) return contentPromise;
  contentPromise = base44.entities.SiteContent.list()
    .then((items) => {
      const data = items.length && items[0].data ? items[0].data : null;
      contentCache = data ? { ...DEFAULT_CONTENT, ...data } : DEFAULT_CONTENT;
      if (data) {
        try { localStorage.setItem(LS_KEY, JSON.stringify(data)); } catch (e) { /* ignore */ }
      }
      return contentCache;
    })
    .catch(() => {
      contentCache = contentCache || DEFAULT_CONTENT;
      return contentCache;
    });
  return contentPromise;
}

export function getInitialSiteContent() {
  return readLocalCache() || DEFAULT_CONTENT;
}

export function useSiteContent() {
  const [content, setContent] = useState(getInitialSiteContent);
  const [loading, setLoading] = useState(!contentCache);

  useEffect(() => {
    let cancelled = false;
    fetchSiteContent().then((data) => {
      if (!cancelled) {
        setContent(data);
        setLoading(false);
      }
    });
    return () => { cancelled = true; };
  }, []);

  return { content, loading };
}